<template>
	<edit></edit>
</template>

<script>
	import edit from './system_role_edit.vue'
	
	export default {
		name: 'role_add',
		
		components: {
			edit
		}
	}
</script>